import styled from "styled-components";
import { StyledDropdownContent } from "app/pages/workspace/sales/components/custom-dropdown/DropdownContent/styles";
import { StyledDropdownSearch } from "app/pages/workspace/sales/components/custom-dropdown/DropdownSearch/styles";

export const StyledItemsContainer = styled.div`
    padding: 8px 0;
`;

export const StyledScrollableBody = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
`;

export const StyledDropdownBody = styled(StyledDropdownContent)`
    display: flex;
    flex-direction: column;
    max-height: 300px;
    width: 320px;

    & ${StyledDropdownSearch} {
        & .input-container {
            input {
                padding: 20px 16px 20px 0;
            }
        }
    }
`;

export const StyledDropdownContainer = styled.div`
    position: relative;
`;
